import clsx from 'clsx'
import PropTypes from 'prop-types'
import MuiAvatar from '@mui/material/Avatar'

const getAvatarInitials = userName =>
  userName
    .split(' ')
    .map(part => part[0])
    .join('')
    .toUpperCase()

const getAvatarColorClass = (userName, email) => {
  const sum = [...userName.split(''), ...email.split('')]
    .map(x => x.charCodeAt(0))
    .reduce((acc, x) => acc + x, 0)

  return Avatar.COLORS[sum % Avatar.COLORS.length]
}

const Avatar = ({ size = Avatar.SIZES[1], userName, email, ...props }) => {
  return (
    <MuiAvatar
      {...props}
      alt={userName}
      className={clsx(size, getAvatarColorClass(userName, email))}
    >
      {getAvatarInitials(userName)}
    </MuiAvatar>
  )
}

Avatar.SIZES = ['big', 'medium', 'small', 'smaller']

Avatar.COLORS = ['colorPurple', 'colorTurquoise', 'colorGreen', 'colorYellow']

Avatar.propTypes = {
  size: PropTypes.oneOf(Avatar.SIZES),
  userName: PropTypes.string,
  email: PropTypes.string,
}

export default Avatar
